/* ==========================================================================
   IRON FIT — the phone strips

   Two rows on the home page, below the showroom: every tool, then every
   accessory. Phones only — on a desktop there is room to lay them out flat
   and a carousel would just be hiding things behind an arrow.

   It is a native scroll-snap strip, not a JS-animated slideshow. A thumb
   already knows how to flick a row sideways, it stays smooth while the page
   is scrolling, and it keeps working with JS switched off — the cards are
   in the HTML, so the worst case is a row you scroll by hand.

   What the script adds on top is the part a thumb cannot do for itself:
   it advances on its own so somebody who never touches it still sees that
   there is more than one, and it wraps past the last card back to the
   first, so the row never dead-ends.

   TOUCHING IT PAUSES IT, IT DOES NOT KILL IT. A row that keeps yanking
   itself along while you are reading a price is infuriating, so a hand on
   it wins immediately — but it picks the loop back up once the hand has
   been still for a few seconds, because a carousel that quietly gave up is
   just a row of cards most people will never scroll.
   ========================================================================== */
(function () {
  'use strict';

  var EVERY = 3600;        /* ms between slides — slow enough to read a price */
  var RESUME_AFTER = 6000; /* quiet time before the loop picks itself back up */

  function build(root) {
    var track = root.querySelector('.strip__track');
    var dotsBox = root.querySelector('.strip__dots');
    if (!track) return;

    var cards = [].slice.call(track.children);
    if (cards.length < 2) return;

    /* one dot per card, and they are buttons because they are tappable */
    var dots = cards.map(function (_, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'strip__dot' + (i === 0 ? ' is-on' : '');
      b.setAttribute('aria-label', 'Show item ' + (i + 1) + ' of ' + cards.length);
      b.addEventListener('click', function () { hold(); go(i); });
      if (dotsBox) dotsBox.appendChild(b);
      return b;
    });

    var at = 0, timer = null, onScreen = false, holdFor = null;

    /* Our own smooth scroll fires the same scroll event a finger does. Without
       this flag the carousel would read its own movement as somebody grabbing
       it and pause itself after every single slide. */
    var mine = false, mineFor = null;

    function go(i) {
      /* the modulo is the loop: past the last card lands on the first */
      at = (i + cards.length) % cards.length;
      mine = true;
      clearTimeout(mineFor);
      mineFor = setTimeout(function () { mine = false; }, 700);
      /* scrollTo rather than scrollIntoView: that one also scrolls the PAGE
         to bring the row into view, which yanks the reader somewhere else */
      track.scrollTo({ left: cards[at].offsetLeft - track.offsetLeft, behavior: 'smooth' });
    }

    /* Which card is actually centred, worked out from the scroll position —
       so the dots stay honest when the row is flicked by hand. */
    function sync() {
      var mid = track.scrollLeft + track.clientWidth / 2;
      var best = 0, bestD = Infinity;
      cards.forEach(function (c, i) {
        var d = Math.abs((c.offsetLeft - track.offsetLeft) + c.offsetWidth / 2 - mid);
        if (d < bestD) { bestD = d; best = i; }
      });
      at = best;
      dots.forEach(function (d, i) { d.classList.toggle('is-on', i === best); });
    }

    function pause() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    function start() {
      if (timer || !onScreen) return;
      timer = setInterval(function () {
        if (document.hidden) return;            /* not while the tab is away */

        /* Wrap on the SCROLL POSITION, not on the card index.

           The last card cannot always be scrolled flush to the left edge —
           its target is past the end of the track, so the browser clamps it.
           sync() then reads whichever card is really centred and can set the
           index back a step, which left the row bouncing between the last
           two cards forever instead of returning to the first. Asking "is
           there anywhere left to scroll?" cannot get stuck that way. */
        if (track.scrollLeft >= track.scrollWidth - track.clientWidth - 4) go(0);
        else go(at + 1);
      }, EVERY);
    }

    /* A hand on the row stops it at once and keeps it stopped while the hand
       is still there; RESUME_AFTER of quiet and it carries on looping. */
    function hold() {
      pause();
      clearTimeout(holdFor);
      holdFor = setTimeout(start, RESUME_AFTER);
    }

    var t = null;
    track.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(sync, 90);
      if (!mine) hold();                        /* a finger, not us */
    }, { passive: true });

    ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(function (ev) {
      track.addEventListener(ev, hold, { passive: true });
    });

    /* Start looping straight away, and let the observer PAUSE it when the row
       is off screen — not the other way round.

       Written the other way round first, and it was fail-closed: the loop
       only ever started if an IntersectionObserver callback arrived, so
       anywhere the callback did not fire the carousel simply sat there
       looking broken. Off-screen ticking costs a scrollTo on an element
       nobody is looking at; never ticking costs the feature. */
    onScreen = true;
    start();

    if (window.IntersectionObserver) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          onScreen = e.isIntersecting;
          onScreen ? start() : pause();
        });
      }, { threshold: 0.3 }).observe(root);
    }
  }

  /* ------------------------------------------------------------------
     The packages pill is position:fixed in the bottom-right corner, so it
     floats over whatever is scrolled underneath — and what ended up
     underneath it was the "See all accessories" button, directly on top of
     each other.

     It belongs to the showroom, and below the showroom the page has proper
     in-flow links to the same place, so it steps aside once the showroom
     has gone by.

     Driven by the scroll position rather than an IntersectionObserver: this
     has to be right every time, and a plain comparison is something you can
     reason about and test anywhere, where the observer only reports once the
     page is actually painting. It is measured off the showroom's own height
     so it keeps working whatever that section ends up being.
     ------------------------------------------------------------------ */
  function pill() {
    var showroom = document.querySelector('.showroom');
    var target = document.querySelector('.saveme');
    if (!showroom || !target) return;
    var root = document.documentElement;

    function check() {
      /* past it when the showroom's last 12% has gone off the top */
      var gone = (window.scrollY || window.pageYOffset || 0) >
                 showroom.offsetTop + showroom.offsetHeight * 0.88;
      root.classList.toggle('ifz-past-showroom', gone);
    }

    addEventListener('scroll', check, { passive: true });
    addEventListener('resize', check, { passive: true });
    check();
  }


  /* ======================================================================
     BUILDING STRIPS FOR THE OTHER PAGES

     The home page ships its two rows as real markup in ifz-home.liquid.
     Every other page gets them from here instead, because "tools and
     accessories under every machine and every bundle" is eight pages and
     eight copies of the same cards is eight places to forget to change a
     price.

     WHAT GOES WHERE
       machine page    bundles, tools, accessories
       bundle page     tools, accessories
       tools page      accessories        (not tools — you are in them)
       accessories     tools              (likewise)

     A page never advertises the thing it already is.
     ====================================================================== */

  var TOOLS = [
    { handle: '46-piece-socket-ratchet-set',        img: 'assets/tool-socket46-760.jpg',     name: '46-Piece Socket & Ratchet Set',    price: '$25' },
    { handle: '115-in-1-precision-screwdriver-set', img: 'assets/tool-precision115-760.jpg', name: '115-in-1 Precision Screwdriver Set', price: '$29' },
    { handle: '108-in-1-professional-tool-set',     img: 'assets/tool-pro108-760.jpg',       name: '108-in-1 Professional Tool Set',   price: '$45' },
    { handle: '128-in-1-complete-repair-kit',       img: 'assets/tool-repair128-760.jpg',    name: '128-in-1 Complete Repair Kit',     price: '$59' }
  ];

  var ACCESSORIES = [
    { handle: 'commercial-adjustable-bench', img: 'assets/spin-bench-1-760.jpg',  name: 'Commercial Adjustable Bench',         price: '$180' },
    { handle: 'olympic-barbell-7-ft',        img: 'assets/spin-bar-1-760.jpg',    name: '7 FT Olympic Bar + Collars',          price: '$120' },
    { handle: '50-kg-chrome-dumbbell-set',   img: 'assets/spin-dbset-1-760.jpg',  name: '50 KG 3-in-1 Dumbbell / Barbell Set', price: '$120' },
    { handle: 'rubber-bumper-plates-per-kg', img: 'assets/spin-plates-1-760.jpg', name: 'Rubber Olympic Plates',               price: '$3 /kg' }
  ];

  /* The packages, with each plate family standing as ONE entry — the same
     collapse the rack does. Seven near-identical posters in a row is exactly
     what the choosers were built to stop, so the strip does not reintroduce
     them three screens further down. */
  var FAMILIES = [
    { key: 'famous', ids: ['famous', 'famous-40', 'famous-60', 'famous-80'], name: 'The Famous Gym' },
    { key: 'smith',  ids: ['smith-starter', 'smith-complete', 'smith-heavy'], name: 'The Smith Gym' }
  ];

  function bundleItems() {
    var all = window.IFZ_BUNDLES || [];
    if (!all.length) return [];

    function famFor(id) {
      for (var i = 0; i < FAMILIES.length; i++) {
        if (FAMILIES[i].ids.indexOf(id) > -1) return FAMILIES[i];
      }
      return null;
    }

    var out = [], done = {};
    all.forEach(function (b) {
      var f = famFor(b.id);
      if (!f) {
        out.push({ href: b.href, img: b.img, name: b.name, price: '$' + b.price });
        return;
      }
      if (done[f.key]) return;
      done[f.key] = 1;

      var tiers = all.filter(function (x) { return f.ids.indexOf(x.id) > -1; });
      if (tiers.length < 2) { out.push({ href: b.href, img: b.img, name: b.name, price: '$' + b.price }); return; }

      var lo = Math.min.apply(null, tiers.map(function (x) { return x.price; }));
      out.push({
        img: b.img,
        name: f.name + ' — ' + tiers.length + ' plate options',
        price: 'from $' + lo,
        /* home + #packages opens the rack; the family key on the trail is
           what puts THAT chooser up rather than the other one */
        href: ((window.IFZ_URLS && window.IFZ_URLS.home) || '/') + '#packages',
        tierTrail: f.key
      });
    });
    return out;
  }

  function cardFor(it) {
    var a = document.createElement('a');
    a.className = 'strip__card';
    a.href = it.href || ('/products/' + it.handle);
    if (it.tierTrail) {
      /* Same as the bundle box above it: raise the chooser here rather than
         load another page to ask which plate weight. The href remains a
         working fallback if ifz-tiers.js is not present. */
      a.addEventListener('click', function (e) {
        if (window.IFZTiers && window.IFZTiers.open(it.tierTrail)) { e.preventDefault(); return; }
        try { sessionStorage.setItem('ifz-pk-tier', it.tierTrail); } catch (err) {}
      });
    }

    var media = document.createElement('span');
    media.className = 'strip__media';
    media.appendChild(window.IFZPic(it.img, it.name));

    var name = document.createElement('span');
    name.className = 'strip__name';
    name.textContent = it.name;

    var price = document.createElement('span');
    price.className = 'strip__price';
    price.innerHTML = it.price + ' <em>Delivered</em>';

    a.appendChild(media);
    a.appendChild(name);
    a.appendChild(price);
    return a;
  }

  function makeStrip(id, kicker, title, lead, items, allHref, allLabel) {
    if (!items.length) return null;
    if (document.getElementById(id)) return null;   /* the page already has one */

    var sec = document.createElement('section');
    sec.className = 'strip';
    sec.id = id;
    sec.setAttribute('aria-label', title);

    var head = document.createElement('div');
    head.className = 'strip__head';
    head.innerHTML =
      '<span class="strip__kicker">' + kicker + '</span>' +
      '<h2 class="strip__title">' + title + '</h2>' +
      '<p class="strip__lead">' + lead + '</p>';

    var track = document.createElement('div');
    track.className = 'strip__track';
    items.forEach(function (it) { track.appendChild(cardFor(it)); });

    var dots = document.createElement('div');
    dots.className = 'strip__dots';
    dots.setAttribute('aria-hidden', 'true');

    var all = document.createElement('a');
    all.className = 'strip__all';
    all.href = allHref;
    all.innerHTML = allLabel + ' <i aria-hidden="true">&rarr;</i>';

    sec.appendChild(head);
    sec.appendChild(track);
    sec.appendChild(dots);
    sec.appendChild(all);
    return sec;
  }

  /* Which page is this? Read off what the page actually contains rather
     than off the URL, which differs between the static build and Shopify. */
  function pageKind() {
    if (document.getElementById('toolGrid')) return 'tools';
    if (document.querySelector('.acc__grid')) return 'accessories';
    if (document.getElementById('bitems')) return 'bundle';
    if (window.IFZ_PRODUCT_KEY) return 'machine';
    return null;
  }

  function mountStrips() {
    var kind = pageKind();
    if (!kind) return;

    var wants = {
      machine:     ['bundles', 'tools', 'accessories'],
      bundle:      ['tools', 'accessories'],
      tools:       ['accessories'],
      accessories: ['tools']
    }[kind] || [];

    var made = [];
    wants.forEach(function (w) {
      var sec = null;
      if (w === 'bundles') {
        sec = makeStrip('stripBundles', 'Packages', 'Check out our bundles',
          'The same machines with the bench, the bar and the plates — one delivery, one price.',
          bundleItems(), '#packages', 'See all packages');
      } else if (w === 'tools') {
        sec = makeStrip('stripTools', 'Tools', 'Every tool set',
          'Bought with a machine or on their own — the same delivery either way.',
          TOOLS, (window.IFZ_URLS && window.IFZ_URLS.tools) || '/pages/tools', 'See all tools');
      } else {
        sec = makeStrip('stripAcc', 'Accessories', 'Every accessory',
          'Add them to a machine and it all arrives together, in one installation visit.',
          ACCESSORIES, (window.IFZ_URLS && window.IFZ_URLS.accessories) || '/pages/accessories', 'See all accessories');
      }
      if (sec) made.push(sec);
    });
    if (!made.length) return;

    /* Placed BEFORE the page's closing "more like this" section, or else
       appended inside the page's own column.

       Before, not after: on a bundle page "The other packages" is a list of
       seven cards, and putting the strips underneath it buried them five
       thousand pixels down a page nobody scrolls that far. Above it they
       land right after the thing the visitor came to read.

       Appending INSIDE .wrap rather than after it matters too — machine
       pages no longer have a closing section at all, and inserting after
       the wrapper would drop these outside the page's max-width and leave
       them full-bleed while everything above stayed inset. */
    var before = document.querySelector('.more') || document.querySelector('.acc__more');
    var inside = document.querySelector('.wrap') || document.body;

    made.forEach(function (sec) {
      if (before && before.parentNode) before.parentNode.insertBefore(sec, before);
      else inside.appendChild(sec);
    });
  }

  function init() {
    mountStrips();                       /* before build(): they need driving too */
    [].forEach.call(document.querySelectorAll('.strip'), build);
    pill();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
